import React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Tooltip from 'venuescanner-js/react/components/Tooltip';

function CloseEnquiry({
  onClick,
  fullWidth,
  variant = 'outlined',
  text = 'Close',
  showTooltip = true,
  size = 'medium-large',
  color = 'white',
}) {
  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent={showTooltip ? 'start' : 'center'}
      spacing={1.5}>
      <Button
        fullWidth={fullWidth}
        variant={variant}
        color={color}
        size={size}
        onClick={onClick}>
        {text}
      </Button>
      {showTooltip && (
        <Tooltip title='After clicking ‘Close’ you will be asked about the reason and will be able to add message to the organiser.' />
      )}
    </Stack>
  );
}

export default CloseEnquiry;
